import { createActionGroup, props } from '@ngrx/store';
import { SupplierAllocation } from '@ps/survey-utils';

export const ManageSurveyReferenceActions = createActionGroup({
  source: 'Manage Survey Reference',
  events: {
    'Load Supplier Allocations': props<{ surveyId: number }>(),
  },
});

export const ManageSurveyReferenceApiActions = createActionGroup({
  source: 'Manage Survey Reference API',
  events: {
    'Load Supplier Allocations Success': props<{
      supplierAllocations: SupplierAllocation[];
    }>(),
    'Load Supplier Allocations Failure': props<{ error: string }>(),
  },
});
